import Http from './Http';
import { API_URL } from '../common/Constant';
export default class API {
  constructor(store) {
    this.store = store;
  }

  init() {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.fire(API_URL.INIT);
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  initLive(roomid) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.fire(API_URL.INIT_LIVE, { room_id: roomid });
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  initVod(recordid) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.fire(API_URL.INIT_VOD, { record_id: recordid });
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }
}
